export default __webpack_public_path__ + "static/media/a017-line8.eb0a76fd.svg";